// 2-10位汉字xxx，后面可以再加两个·yyy·zzz
var regChinaName = /^[\u4E00-\u9FA5\uF900-\uFA2D]{2,6}([·•][\u4E00-\u9FA5\uF900-\uFA2D]{1,6}){0,2}$/;
// 15 位身份证号: 6 位地区号, 2 位年份后两位, 2 位月份, 2 位日子, 3 位顺序码(最后一位奇数为男偶数为女)
var regIdentity15 = /^([1-9]\d{5})(\d{2})((?:0[1-9])|(?:10|11|12))((?:[0-2][1-9])|10|20|30|31)\d{3}$/;
// 18 位身份证号: 6位地区号, 4位年份, 2位月份, 2位日子, 3位顺序码, 1位校验码
var regIdentity18 = /^([1-9]\d{5})((?:19|20)\d{2})((?:0[1-9])|(?:10|11|12))((?:[0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
// 银行卡号
var regCard = /^\d{16,19}$/;
// 手机号
var regPhone = /^(00|11|13|14|15|16|17|18|19)[0-9]{9}$/;
var default_1 = /** @class */ (function () {
    function default_1() {
    }
    /**
     * 校验名字 (只支持汉字)
     * @param name
     */
    default_1.validateName = function (name) {
        // name = (name + '').replace(/·|•/ig, '')
        return regChinaName.test(name);
    };
    /**
     * 校验身份证
     * @param identity
     */
    default_1.validateIdentity = function (identity) {
        if (!identity)
            return;
        var identityStr = identity + '';
        return identityStr.length === 15 ?
            regIdentity15.test(identityStr) : identityStr.length === 18 ?
            regIdentity18.test(identityStr) : false;
    };
    /**
     * 校验银行卡号
     * @param cardNo
     */
    default_1.validateCardNo = function (cardNo) {
        return regCard.test(cardNo);
    };
    /**
     * 校验手机号
     * @param phone
     */
    default_1.validatePhone = function (phone) {
        return regPhone.test(phone);
    };
    return default_1;
}());
export default default_1;
